import http, { request } from "@config/http";
import { Page, Pagination } from "@services/common/model/page.model";
import { LoginPayloadModel, TokenModel } from "./model/account.model";

export const loginApi = async (params: LoginPayloadModel) => {
  return http.post<null, Page<TokenModel>>(
    `lite/lite_user/email_login_register`,
    {
      ...params,
    }
  );
};

export const checkEmailApi = async (email: string) => {
  return request.post<null, Page<null>>(`user/check_email`, {
    email,
  });
};

export const sendEmailApi = async (email: string, source: string) => {
  return http.post<null, Page<null>>(`user/send_email`, { email, source });
};

export const checkNeedOrgnizationApi = async (email: string) => {
  return http.post<null, Page<{ show_org_collect: boolean }>>(
    `lite/lite_user/geo_flow_login_send_email_code`,
    {
      email,
    }
  );
};
